<template>
  <div class="portlet light">
    <div class="portlet-body">
      <div>
        <div>
          <div class="portlet light">
            <div class="portlet-title">
              <div class="caption">
                <span class="caption-subject bold uppercase">Request Submitted</span>
              </div>
            </div>
            <div class="portlet-body"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnhancementStatus",
  props: ["profile", "jira"],
  components: {}
};
</script>
